import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const importEndpoint = `${apiUrl}/smq/Import`;

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Impossible d’archiver le fichier d’import";

const ImportService = {
  async archive(file, constatId) {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("constat_id", constatId);

    try {
      const response = await axios.post(importEndpoint, formData);
      if (response?.data?.status === false) {
        throw new Error(response.data.message || "Archivage impossible");
      }
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default ImportService;
